import { WinProbabilityRow } from '../types/win-probabilty.ts'
// Updated helper to handle the "minus" naming convention correctly
export default function getVal(
    row: WinProbabilityRow,
    shouldFlip: boolean,
    scoreDiff: number
): string {
    // scoreDiff is negative on the left (-5 to -1) and positive on the right (1 to 5)
    // If perspective is 'bat', negative diffs mean "Batting team leading"
    // If perspective is 'bat' and it's the Bottom (Home bats), a Batting Lead is actually a Home Lead.
    let key: string
    const absDiff = Math.abs(scoreDiff)

    if (scoreDiff === 0) {
        key = 'bat_wins_0'
    } else if (shouldFlip) {
        // Left side (-5) becomes Home +5, Right side (+5) becomes Home -5
        key =
            scoreDiff < 0 ? `bat_wins_${absDiff}` : `bat_wins_minus_${absDiff}`
    } else {
        // Standard behavior
        key =
            scoreDiff < 0 ? `bat_wins_minus_${absDiff}` : `bat_wins_${absDiff}`
    }

    return (100 * Number(row[key as keyof WinProbabilityRow] ?? 0)).toFixed(1)
}
